// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__1zRLT","header":"Messages_header__sS8a2"};